import { render, staticRenderFns } from "./MenuFooter.vue?vue&type=template&id=10dd4a27&scoped=true"
import script from "./MenuFooter.vue?vue&type=script&lang=js"
export * from "./MenuFooter.vue?vue&type=script&lang=js"
import style0 from "./MenuFooter.vue?vue&type=style&index=0&id=10dd4a27&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dd4a27",
  null
  
)

export default component.exports